var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{on:{"drower":function($event){return _vm.$refs.mobileMenu.toggle()}}}),(_vm.isMobile)?_c('MobileMenu',{ref:"mobileMenu"}):_vm._e(),_c('router-view'),(!_vm.isEmbed)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }